module.exports = __webpack_public_path__ + "static/img/dance.d354af32.webp";